import { render, staticRenderFns } from "./ErrorMessages.vue?vue&type=template&id=3852fd3b&"
import script from "./ErrorMessages.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessages.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorMessages.vue?vue&type=style&index=0&id=3852fd3b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports